// Centralized content for Fresh Fast Foods LLC catering site.

export const BRAND = {
  name: "Fresh Fast Foods LLC",
  associated: "Burgers Tacos Wings & Seafood / BTWNYC",
  logo: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/F3-LOGO%20w_%20stroke-17de8a1.png/:/rs=h:200,cg:true,m/qt=q:95",
  phone: "(929) 272-5704",
  phoneTel: "+19292725704",
  email: "info@btwnyc.com",
  serviceArea: "Jamaica, Queens, NY · Serving NYC (5 Boroughs) and Long Island",
  pickupAddress: "110-46 Merrick Blvd, Jamaica, NY 11433",
  menuPdf:
    "https://customer-assets.emergentagent.com/wingman/9c8ef01f-de5d-404e-b131-b692bd44c30d/attachments/152c70147df644dea968c11d6eaa5689_Fresh_Fast_Foods_Catering_Menu.pdf",
  social: {
    instagram: "https://www.instagram.com/burgerstacoswings",
    instagramHandle: "@burgerstacoswings",
    tiktok: "https://www.tiktok.com/@btwnyc",
    tiktokHandle: "@btwnyc",
  },
};

export const NAV_LINKS = [
  { label: "Packages", href: "/#packages" },
  { label: "Who We Serve", href: "/who-we-serve" },
  { label: "Why Us", href: "/why-us" },
  { label: "How We Cater", href: "/how-we-work" },
  { label: "Partner", href: "/partner" },
  { label: "Community", href: "/#community" },
  { label: "Gallery", href: "/gallery" },
];

export const HERO_BADGES = [
  "NYC Vendor",
  "DOE Vendor",
  "MWBE Certified",
  "Community-Based",
  "QSR Operator",
];

export const HERO_STATS = [
  {
    label: "School & Agency Catering",
    icon: "GraduationCap",
    description:
      "DOE schools, NYC agencies, after-school programs, and community-based nonprofits. We handle volume, dietary needs, and tight delivery windows so your team can focus on the day, not the logistics.",
    bullets: [
      "Vendor-registered with NYC DOE & city agencies",
      "Hot, cold, or grab-and-go formats",
      "Allergen labels and pickup/delivery options",
    ],
  },
  {
    label: "Office Lunches",
    icon: "Building2",
    description:
      "Reliable, crowd-pleasing lunches for team meetings, client visits, and all-hands days. Order recurring lunches weekly or one-off for a big day.",
    bullets: [
      "10–200 guests, scaled to your headcount",
      "Hot trays, boxed meals, or buffet setup",
      "Beverages, utensils, and full setup included",
    ],
  },
  {
    label: "Private Events",
    icon: "Sparkles",
    description:
      "Birthdays, milestones, family gatherings, and church functions — done with the same professional touch as our agency work, at a private retail price.",
    bullets: [
      "Customizable menus from our full catalog",
      "Optional waitstaff and on-site setup",
      "Stripe checkout — no purchase order needed",
    ],
  },
  {
    label: "Activations",
    icon: "Megaphone",
    description:
      "Brand activations, pop-ups, premieres, and street-team events around NYC. We bring crowd-energy food (wings, sliders, tacos) plus the logistics to feed long lines fast.",
    bullets: [
      "Quick-service speed (BTWNYC kitchen roots)",
      "Branded service stations on request",
      "Permitted catering for outdoor & public events",
    ],
  },
  {
    label: "Grab-and-Go Meals",
    icon: "ShoppingBag",
    description:
      "Individually packaged boxed meals for staff appreciation, programs that span shifts, or quick service to long guest lines.",
    bullets: [
      "Hot or cold packaging, labeled per guest",
      "Allergen-aware menus available",
      "Stackable for easy dropoff at multiple sites",
    ],
  },
  {
    label: "Buffet & Tray Service",
    icon: "ChefHat",
    description:
      "Full hot/cold trays with burner setup, serving utensils, and clean presentation. Great for offices, community halls, and family-style gatherings.",
    bullets: [
      "Chafing dishes & burners included on request",
      "Disposable or ceramic serving options",
      "Optional on-site staff for buffet refills",
    ],
  },
];

export const TRUST_BADGES = [
  {
    slug: "doe-vendor",
    title: "DOE Vendor",
    subtitle: "Registered with NYC Dept. of Education",
    icon: "GraduationCap",
    image:
      "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=900&q=60",
  },
  {
    slug: "nyc-vendor",
    title: "NYC Vendor",
    subtitle: "Serving city agencies & programs",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?auto=format&fit=crop&w=900&q=60",
  },
  {
    slug: "mwbe-certified",
    title: "MWBE Certified",
    subtitle: "Minority & Women-Owned Business",
    icon: "BadgeCheck",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=60",
  },
  {
    slug: "queens-based",
    title: "Queens-Based",
    subtitle: "Rooted in Jamaica, Queens, NY",
    icon: "MapPin",
    image:
      "https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?auto=format&fit=crop&w=900&q=60",
  },
  {
    slug: "workforce-development",
    title: "Workforce Development",
    subtitle: "SYEP & community hiring partners",
    icon: "Users",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=900&q=60",
  },
  {
    slug: "restaurant-catering",
    title: "Restaurant + Catering",
    subtitle: "BTWNYC quick-service operator",
    icon: "ChefHat",
    image:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=60",
  },
];

export const PACKAGES = [
  {
    id: "wings-sliders",
    name: "Wings, Sliders & Fries Package",
    image:
      "https://static.prod-images.emergentagent.com/jobs/9c8ef01f-de5d-404e-b131-b692bd44c30d/images/2018c9788822fc78159d3e2898525e6ebd7c1ecca3093c62e6dc54f7d4c3a109.png",
    description:
      "A high-energy crowd favorite built around BTWNYC's quick-service roots — sauced wings done right, paired with sliders and fries. Perfect for parties, youth programs, office lunches, and game-day events.",
    includes: [
      "Sauced wings or tenders (mild, hot, BBQ, lemon pepper, garlic parm)",
      "Chicken sliders and cheeseburger sliders",
      "Hand-cut fries or seasoned fries",
      "House sauces, ranch, blue cheese",
      "Optional canned soda, bottled water, or fresh fruit drinks",
    ],
    bestFor: "Private events, youth programs, office lunches, casual celebrations",
  },
  {
    id: "breakfast",
    name: "Breakfast & Brunch Package",
    image:
      "https://static.prod-images.emergentagent.com/jobs/9c8ef01f-de5d-404e-b131-b692bd44c30d/images/e525c451284d223f21c590e303094e57a2a91b79ab26905ed97da58b37e40461.png",
    description:
      "A reliable morning catering package for meetings, staff appreciation, school programs, early events, and agency gatherings — built for fast, professional setup.",
    includes: [
      "Assorted bagels with cream cheese & butter",
      "Breakfast sandwiches or wraps (turkey bacon / beef sausage options)",
      "Eggs and cheese, breakfast potatoes or grits",
      "Fresh fruit platters",
      "Box of coffee (regular & decaf) and assorted juices",
      "Bottled water available",
    ],
    bestFor: "Morning meetings, school staff breakfasts, agency events, workshops",
  },
  {
    id: "desserts",
    name: "Dessert Catering Package",
    image:
      "https://static.prod-images.emergentagent.com/jobs/9c8ef01f-de5d-404e-b131-b692bd44c30d/images/df7c32d58ab36faca2bc787c672b647aa803179c533507a5d8001946bda5b062.png",
    description:
      "A signature dessert spread that turns any event into a celebration — full-size cakes, mousse cups, and cookie platters from our trusted bakery partners.",
    includes: [
      "Red Velvet cake (whole or sliced)",
      "Carrot cake with cream cheese frosting",
      "Oreo mousse cups",
      "New York-style cheesecake",
      "Assorted gourmet cookies (chocolate chip, oatmeal, sugar)",
      "Optional plated presentation or grab-and-go boxes",
    ],
    bestFor: "Office celebrations, church events, birthdays, milestone gatherings",
  },
  {
    id: "soul-food",
    name: "Soul Food & Southern Comfort Package",
    image:
      "https://images.unsplash.com/photo-1558329243-98f14662794f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxjaGlja2VuJTIwd2luZ3MlMjBzbGlkZXJzJTIwYW5kJTIwc2FsYWRzfGVufDB8fHx8MTc3ODcxMzQ0N3ww&ixlib=rb-4.1.0&q=85",
    description:
      "A hearty catering spread featuring classic comfort food, seafood, and crowd-tested sides for larger gatherings and special events.",
    includes: [
      "Meat & seafood: jerk chicken, grilled chicken, fried fish, shrimp",
      "Baked ziti, mac and cheese, and pasta platters",
      "Salads & platters: garden salad, pasta salad, fruit platter",
      "Side dishes: collard greens, rice and peas, yams, cornbread",
      "House sauces and condiments",
    ],
    bestFor: "Church events, community gatherings, private celebrations, agency functions",
  },
];

export const SERVICE_STYLES = [
  {
    title: "Individually Packaged Meals",
    description: "Great for schools, agencies, offices, and grab-and-go events.",
    icon: "Package",
  },
  {
    title: "Catering Trays",
    description: "Perfect for buffet-style service and larger groups.",
    icon: "Utensils",
  },
  {
    title: "Staffed Events",
    description: "Servers, grill staff, and event support available when needed.",
    icon: "UserCheck",
  },
  {
    title: "Delivery & Setup",
    description: "Hot, organized, labeled, and ready to serve.",
    icon: "Truck",
  },
];

export const WHO_WE_SERVE = [
  { title: "Schools & Youth Programs", desc: "DOE-vendor catering for breakfasts, events, and program lunches." },
  { title: "NYC Agencies", desc: "Reliable, on-time service for meetings, hearings & workshops." },
  { title: "Corporate Offices", desc: "Weekly lunches, team appreciations, and client events." },
  { title: "Nonprofits", desc: "Mission-aligned catering that respects budgets." },
  { title: "Churches & Community Groups", desc: "Hearty spreads for fellowship gatherings & events." },
  { title: "Private Events", desc: "Birthdays, family celebrations, and milestone occasions." },
  { title: "Production Shoots", desc: "Crew meals, craft service, and on-set catering." },
  { title: "Staff Appreciation Events", desc: "Custom packages that say thank you, well." },
  { title: "Workshops & Trainings", desc: "Packaged meals and break refreshments for all-day sessions." },
  { title: "Airport / Concession Opportunities", desc: "Scalable QSR operations for travel-hub partners." },
];

export const WHY_US = [
  {
    title: "Operationally Ready",
    body: "Built from real restaurant systems, not just one-off catering.",
    icon: "Settings2",
  },
  {
    title: "Community Rooted",
    body: "A Queens-based company committed to local workforce development and opportunity.",
    icon: "HeartHandshake",
  },
  {
    title: "Professionally Positioned",
    body: "Vendor-ready, agency-ready, school-ready, and event-ready.",
    icon: "ShieldCheck",
  },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjYXRlcmluZyUyMHNwcmVhZHxlbnwwfHx8fDE3Nzg3MTM0NDd8MA&ixlib=rb-4.1.0&q=85", label: "Catering Spread" },
  { src: "https://images.unsplash.com/photo-1611698529138-c5968262a080?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjaGlja2VuJTIwd2luZ3MlMjBzbGlkZXJzJTIwYW5kJTIwc2FsYWRzfGVufDB8fHx8MTc3ODcxMzQ0N3ww&ixlib=rb-4.1.0&q=85", label: "Sauced Wings" },
  { src: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/IMG_6DAC737D2809-1.jpeg", label: "Food Service Team" },
  { src: "https://images.unsplash.com/photo-1672826979217-7156a305acf5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxjYXRlcmluZyUyMHNwcmVhZHxlbnwwfHx8fDE3Nzg3MTM0NDd8MA&ixlib=rb-4.1.0&q=85", label: "Breakfast & Brunch" },
  { src: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&w=1200&q=85", label: "Red Velvet & Cheesecake" },
  { src: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/IMG_7179.jpg", label: "Community Event" },
  { src: "https://images.unsplash.com/photo-1558329243-98f14662794f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxjaGlja2VuJTIwd2luZ3MlMjBzbGlkZXJzJTIwYW5kJTIwc2FsYWRzfGVufDB8fHx8MTc3ODcxMzQ0N3ww&ixlib=rb-4.1.0&q=85", label: "Soul Food Spread" },
  { src: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/IMG_D894B71550BA-1.jpeg", label: "Staff Training" },
];

export const COMMUNITY_IMAGES = {
  primary: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/IMG_7165.jpg",
  secondary: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/IMG_7167.jpg",
  tertiary: "https://img1.wsimg.com/isteam/ip/f73297d8-4b43-481b-a2c1-3a058376af76/IMG_7168.jpg",
};

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Submit a Quote Request",
    desc: "Tell us your date, guest count, location, budget, and menu interests.",
  },
  {
    num: "02",
    title: "Choose Your Package",
    desc: "We recommend the right menu and service style for your event.",
  },
  {
    num: "03",
    title: "Confirm Details",
    desc: "We finalize timing, delivery, setup, staffing, and payment.",
  },
  {
    num: "04",
    title: "We Feed the Room",
    desc: "Your order arrives organized, hot, labeled, and ready.",
  },
];

export const FAQS = [
  {
    q: "Do you cater schools and agencies?",
    a: "Yes. Fresh Fast Foods LLC provides catering for schools, agencies, offices, nonprofits, and community events. We are a registered NYC DOE vendor and serve city-agency programs across NYC (5 Boroughs) and Long Island.",
  },
  {
    q: "Do you offer individually packaged meals?",
    a: "Yes. Individually packaged meals are available and are a great option for schools, staff lunches, meetings, and grab-and-go events.",
  },
  {
    q: "Can you provide staff for events?",
    a: "Yes. Staffed service may be available depending on the event size, location, and service style. Tell us the details in your quote request.",
  },
  {
    q: "Do you offer custom menus?",
    a: "Yes. We can customize packages based on guest count, budget, dietary needs, and event type, including vegetarian, halal-style, and gluten-aware options.",
  },
  {
    q: "How far in advance should I request catering?",
    a: "We recommend submitting requests as early as possible — especially for large events, schools, agencies, and staffed events. Smaller orders can often be handled with shorter notice.",
  },
  {
    q: "Do you provide delivery and setup?",
    a: "Yes. Delivery and setup options are available based on the event details, location, and timing.",
  },
];

export const EVENT_TYPES = [
  "School Event",
  "Agency Meeting",
  "Office Lunch",
  "Nonprofit / Community Event",
  "Private Party",
  "Church Event",
  "Production / Media Event",
  "Other",
];

export const PACKAGE_OPTIONS = [
  "Wings, Sliders & Fries Package",
  "Breakfast & Brunch Package",
  "Dessert Catering Package",
  "Soul Food & Southern Comfort Package",
  "Custom Catering",
];

export const SERVICE_STYLE_OPTIONS = [
  "Delivery Only",
  "Delivery + Setup",
  "Staffed Event",
  "Individually Packaged Meals",
  "Catering Trays / Buffet",
  "Not Sure Yet",
];

export const BUDGET_RANGES = [
  "Under $500",
  "$500–$1,000",
  "$1,000–$2,500",
  "$2,500–$5,000",
  "$5,000+",
];
